var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10002_5260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.15161C9.4375 0.557861 9.4375 0.557861 9.4375 0.557861C9.46875 0.589111 9.46875 0.589111 9.5 0.589111C9.53125 0.620361 9.59375 0.682861 9.65625 0.714111C9.78125 0.839111 9.96875 0.995361 10.1875 1.18286C10.6562 1.55786 11.25 2.15161 11.875 2.87036C12.9688 4.12036 14.1562 5.90161 14.5938 8.02661C15.125 7.74536 15.9688 7.40161 17 7.40161C17 7.40161 20 7.40161 20 10.9016C20 15.9016 15.5 16.4016 14 16.4016C13.3438 16.4016 12.1875 16.2454 11.0312 15.6829C12.1562 14.6829 13 13.1516 13 10.9016C13 9.24536 12.4062 8.15161 11.625 7.46411C12.1562 7.52661 12.625 7.68286 13 7.87036C12.5625 6.27661 11.6562 4.90161 10.7188 3.83911C10.2812 3.33911 9.84375 2.90161 9.46875 2.55786C9.375 2.96411 9.25 3.43286 9.0625 3.96411C8.71875 5.05786 8.15625 6.40161 7.3125 7.71411C7.78125 7.55786 8.34375 7.40161 9 7.40161C9 7.40161 12 7.40161 12 10.9016C12 15.9016 7.5 16.4016 6 16.4016C4.5 16.4016 0 15.4016 0 10.9016C0 7.40161 3 7.40161 3 7.40161C3.9375 7.40161 4.75 7.71411 5.28125 7.96411C6.46875 6.43286 7.21875 4.80786 7.65625 3.49536C7.90625 2.77661 8.03125 2.15161 8.125 1.71411C8.1875 1.52661 8.1875 1.33911 8.21875 1.24536C8.21875 1.18286 8.25 1.15161 8.25 1.12036V1.08911C8.28125 0.807861 8.4375 0.589111 8.6875 0.464111C8.9375 0.370361 9.21875 0.401611 9.4375 0.557861L9 1.15161Z",
    fill: "black",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10002_5260",
    x: 0,
    y: 0.370361,
    width: 20,
    height: 17.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10002_5260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10002_5260",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default ForwardRef;